import type { createFramesClient } from "@connect/data/frames/client";

type FramesClient = ReturnType<typeof createFramesClient>;

export function requestCardGrant(client: FramesClient, cardIds: string[]) {
  return client.POST("/platform/v1/partner/grants", {
    body: { purpose: "card_passback", resources: cardIds },
  });
}
